import React from 'react';

export function FontSize(editor) {
  const { Canvaseditor } = editor;
  // Size Picker.
  const handleFontSizeChange = (event) => {
    const activeObj = Canvaseditor.getActiveObject();
    const newFontSize = event.target.value;
    if (activeObj) {
      activeObj.set('fontSize', parseInt(newFontSize));
      // Reset stored original so auto-shrink uses new size
      activeObj._originalFontSize = parseInt(newFontSize);
      activeObj._originalHeight = activeObj.height || activeObj.calcTextHeight();
      Canvaseditor.renderAll();
      if (typeof Canvaseditor.fire === "function") Canvaseditor.fire("canvas:state-changed");
    }
  };
  return (
    <div className="font-size-container">
      <select
        style={{ padding: '7px 3px 4px 12px' }}
        id="text-font-size"
        onChange={handleFontSizeChange}
      >
        <option value="">Select Size</option>
        {(() => {
          const options = [];
          for (let i = 1; i <= 250; i++) {
            options.push(
              <option key={i} value={i}>
                {i}
              </option>
            );
          }
          return options;
        })()}
      </select>
    </div>
  );
}
